import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class FacetOverlayMonitorService {
    private _activeOverlay: string = null;

    public getActiveOverlay(): string {
        return this._activeOverlay;
    }

    public setActiveOverlay(facetAlias: string): void {
        this._activeOverlay = facetAlias;
    }

    public removeActiveOverlay(): void {
        this._activeOverlay = null;
    }
}
